// Common function for making HTTP requests
import axios from "axios";
import * as Sentry from "@sentry/gatsby";

// Instance
const axiosInstance = axios.create({
  // Your custom configuration here
});

const makeRequest = {
  async request(method, url, headers, data = {}) {
    try {
      const response = await axiosInstance({
        method,
        url,
        headers: headers || { "Content-Type": "application/json" },
        data,
      });
      return response;
    } catch (error) {
      Sentry?.captureException?.(error);
      console.error("Error fetching data:", error);
      return error;
    }
  },
  async get(url, headers) {
    return this.request("get", url, headers);
  },
  async post(url, data = {}, headers) {
    return this.request("post", url, headers, data);
  },
};

export default makeRequest;
